import React, { useState } from 'react';
import './Feedback.css';

const Feedback = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  // Просто имена файлов, если они в public/img/
  const feedbackPhotos = [
    { id: 1, url: '/img/1.jpg', alt: "Отзыв клиента Monxuan" },
    { id: 2, url: '/img/2.jpg', alt: "Отзыв клиента Monxuan" },
    { id: 3, url: '/img/3.jpg', alt: "Отзыв клиента Monxuan" },
    { id: 4, url: '/img/4.jpg', alt: "Отзыв клиента Monxuan" }
  ];

  const openModal = (image) => {
    setSelectedImage(image);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  return (
    <section className="feedback" id="feedback">
      <div className="container">
        <div className="feedback-header">
          <h2 className="section-title">Відгуки клієнтів</h2>
          <p className="section-subtitle">
            Реальні відгуки наших задоволених клієнтів
          </p>
        </div>

        <div className="feedback-gallery">
          {feedbackPhotos.map(photo => (
            <div 
              key={photo.id} 
              className="feedback-item"
              onClick={() => openModal(photo)}
            >
              <img 
                src={photo.url} 
                alt={photo.alt}
                className="feedback-image"
                loading="lazy"
              />
            </div>
          ))}
        </div>

        {selectedImage && (
          <div className="feedback-modal-overlay" onClick={closeModal}>
            <div className="feedback-modal" onClick={(e) => e.stopPropagation()}>
              <button className="modal-close-btn" onClick={closeModal}>×</button>
              <img 
                src={selectedImage.url} 
                alt={selectedImage.alt}
                className="modal-image"
              />
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Feedback;